export const OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT = 'api/v1/custom_alarm_definitions';

const DEFINED_FROM_DOMAIN_TYPE = 'DEVICE_TYPE';
const APPLICABLE_TO_DOMAIN_TYPE = 'OPERATOR';

export const buildOperatorCustomNotificationsEndpoint = (showInactive: boolean): string => {
    const params = new URLSearchParams({
        definedFromDomainType: DEFINED_FROM_DOMAIN_TYPE,
        applicableToDomainType: APPLICABLE_TO_DOMAIN_TYPE,
    });

    if (!showInactive) {
        params.set('onlyActive', 'true');
    }

    return `${OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT}?${params.toString()}`;
};

export const buildOperatorCustomNotificationEndpoint = (id: string): string =>
    `${OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT}/${id}`;

export const OPERATOR_CUSTOM_NOTIFICATIONS_ACTIVE_ENDPOINT = `${OPERATOR_CUSTOM_NOTIFICATIONS_ENDPOINT}/active`;
